

















































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Form } from '@/shared/forms/form'
import { MessageForm } from '@/business/message/models/message-form'
import { MessageRequest } from '@/api/generated'
import RespondecoForm from '@/shared/components/respondeco-form.vue'
import { Injector } from '@/config/dependency-injection'
import { MessageModule } from '@/business/message/store/message-module'
import { NotificationService } from '@/shared/services/notification-service'
import { Focusable } from '@/shared/interfaces/focusable'
import { Key } from 'ts-key-enum'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { CREATE_MESSAGE } from '@/business/message/store/types'
import UnifyTextarea from '@/shared/components/unify/unify-textarea.vue'
import UnifyButton from '@/shared/components/unify/unify-button.vue'

@Component({
  components: { UnifyButton, UnifyTextarea, RespondecoForm },
  data() {
    return {
      form: new Form(MessageForm, this),
    }
  },
})
export default class NewMessage extends Vue implements Focusable {
  @Prop({
    type: Number,
    required: true,
  })
  public readonly receiver!: number

  public get loading() {
    return this.loaderHelper.isLoading(CREATE_MESSAGE)
  }

  public form!: Form<MessageRequest, MessageForm>

  private loaderHelper = Injector.get(LoaderHelper)
  private messageModule = Injector.get(MessageModule)
  private notificationService = Injector.get(NotificationService)

  public mounted() {
    this.$watch(
      () => this.receiver,
      newValue => {
        this.form.value.receiver = newValue
      }
    )

    this.form.value.receiver = this.receiver
  }

  public focus() {
    const textarea: Focusable = (this.$refs.textarea as unknown) as Focusable

    textarea.focus()
  }

  public onKeyDown(event: KeyboardEvent) {
    if (event.key === Key.Enter && event.ctrlKey) {
      this.submit()
    }
  }

  public submit() {
    const model = this.form.serialize()

    this.messageModule
      .createMessage(model)
      .then(() => {
        this.notificationService.success()

        this.form.deserialize({
          receiver: this.receiver,
        })
      })
      .catch(this.notificationService.errorHandler())
  }

  public validations() {
    return this.form.validations()
  }
}
